// String.prototype.replaceAll polyfill for older browsers (Chromium < 85,
// shipped 2020-08). Required for some Chinese WebViews — QQBrowser, Quark,
// HarmonyOS embedded browser — which lag behind on ES2021 features.
//
// On modern browsers the native method is kept; the polyfill is skipped.
//
// "e.replaceAll is not a function" thrown from multiple unrelated
// components (decodeURIText, TransferPage). Same error across different
// code paths is the signature of a missing built-in, not a data bug.
if (!String.prototype.replaceAll) {
  // eslint-disable-next-line no-extend-native
  String.prototype.replaceAll = function (search, replacement) {
    if (
      Object.prototype.toString.call(search).toLowerCase() === "[object regexp]"
    ) {
      return this.replace(search, replacement);
    }
    return this.replace(
      new RegExp(
        String(search).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
        "g"
      ),
      replacement
    );
  };
}
